import React from 'react';
import PropTypes from 'prop-types';

import Grid from '../../components/Grid';
import RatingsOverview from './overview';
import RatingsUserList from './user-list';
import RatingsMemberDetails from '../RepVisitsRatingsMemberDetails';
import NoRatings from './no-ratings';

import './styles.css';

class RatingsPage extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    schoolYear: PropTypes.string,
  };

  state = {
    selectedUser: null,
  };

  onUserSelected = (user) => {
    this.setState({ selectedUser: user });
    /* istanbul ignore if */
    if (this.container && this.container.getBoundingClientRect().top < 0) {
      this.container.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
  };

  backToPage = () => {
    this.setState({ selectedUser: null });
  };

  renderDetails() {
    const { schoolYear, viewer: { repVisits: { ratings } } } = this.props;
    const { selectedUser } = this.state;

    if (!ratings.overview.numRatings) {
      return <NoRatings />;
    }

    if (selectedUser) {
      return (
        <RatingsMemberDetails
          user={selectedUser}
          backToPage={this.backToPage}
          schoolYear={schoolYear}
        />
      );
    }

    return <RatingsOverview ratings={ratings} />;
  }

  render() {
    const { selectedUser } = this.state;
    const { userList } = this.props.viewer.repVisits.ratings;
    return (
      <div ref={(el) => { this.container = el; }}>
        <Grid>
          <Grid.Row styleName="page-row">
            <Grid.Column width={4} styleName="user-list-container">
              <RatingsUserList
                users={userList}
                onUserSelected={this.onUserSelected}
                selectedUser={selectedUser}
              />
            </Grid.Column>
            <Grid.Column width={12} styleName="ratings-container">
              {this.renderDetails()}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default RatingsPage;
